import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20abstract%20illustration%20of%20hidden%20knowledge%20and%20secret%20teaching%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20geometric%20patterns%2C%20book%20pages%20turning%20into%20flowing%20light%2C%20ethereal%20atmosphere%2C%20no%20text%20no%20words&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="秘密教学 - 解锁隐藏知识的高效学习法"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          解锁隐藏知识的<strong className="text-white">高效学习法</strong>
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          揭示课堂之外、教科书背后的核心学习方法。深度解析秘密教学的概念来源、核心价值与实战应用，帮助每一位渴望成长的人掌握被低估的学习捷径。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hexin-fangfa"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center">
          <div className="w-1 h-2.5 bg-white/60 rounded-full mt-1.5 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}